import { BaseModel, fillOwnProperties } from '~/shared/model'
import { isUnknownObject } from '~/shared/utils/guards'

export default class LandingAdvantagesItem extends BaseModel {
  static override constructorName = 'LandingAdvantagesItem'

  _index: string = ''
  'bg_color': string = ''
  'item_number': string = ''
  'item_text': string = ''
  'text_color': string = ''
  link: string = ''
  'is_target_blank': boolean = false

  constructor(data?: unknown) {
    super(data)
    if (isUnknownObject(data)) {
      fillOwnProperties(this, data, ['is_target_blank'])

      this.is_target_blank = Boolean(Number(data.is_target_blank))
    }
  }
}
